import React from 'react'
import { DataCard } from '@/components/DataCard/DataCard'
import { FormField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { ChangePassword } from 'api/Identity/Types/ChangePassword'
import { Form, FormikErrors, FormikProps, withFormik } from 'formik'
import {
  FormSubmitValues,
  LowerCasePattern,
  NumberPattern,
  SymbolPattern,
  UpperCasePattern,
} from 'utils/formValidation'

const UserProfilePasswordFormUI: React.FC<FormikProps<ChangePassword> & OuterProps> = (props) => {
  const { handleSubmit, setSubmitting, isSubmitting } = props
  const handleSubmitForm = () => {
    setSubmitting(true)
    handleSubmit()
  }

  return (
    <Form onSubmit={handleSubmitForm}>
      <DataCard title='Change Password'>
        <FormField label='Current Password' name='currentPassword' type='password' />
        <FormField label='New Password' name='newPassword' type='password' />
        <Button className='mx-auto' disabled={isSubmitting} size='lg' onClick={handleSubmitForm}>
          Save Changes
          {isSubmitting && <Spinner />}
        </Button>
      </DataCard>
    </Form>
  )
}

interface OuterProps {
  onSubmit(values: FormSubmitValues<ChangePassword>): Promise<void>
}

export const UserProfilePasswordForm = withFormik<OuterProps, ChangePassword>({
  mapPropsToValues: () => {
    return {
      newPassword: '',
      currentPassword: '',
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(values)
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<ChangePassword> = {}
    if (!values.newPassword) {
      errors.newPassword = 'Required'
    } else if (values.newPassword.length < 12) {
      errors.newPassword = 'The password should be at least 12 characters.'
    } else if (values.newPassword.length > 128) {
      errors.newPassword = 'The password maximum length is 128 characters.'
    } else if (!LowerCasePattern.test(values.newPassword)) {
      errors.newPassword = 'The password needs contain at least one lower character.'
    } else if (!UpperCasePattern.test(values.newPassword)) {
      errors.newPassword = 'The password needs contain at least one upper character.'
    } else if (!NumberPattern.test(values.newPassword)) {
      errors.newPassword = 'The password needs contain at least one digit'
    } else if (!SymbolPattern.test(values.newPassword)) {
      errors.newPassword = 'The password must contain at least 1 symbol (*@!#%&()^~{}+%$_-)'
    }
    if (!values.currentPassword) {
      errors.currentPassword = 'Required'
    }
    return errors
  },

  enableReinitialize: true,
})(UserProfilePasswordFormUI)
